{
  "tabs": {
    "chat": "Bisedë",
    "reminders": "Kujtese",
    "calendar": "Kalendar",
    "settings": "Cilësimet"
  },
  "common": {
    "cancel": "Anulo",
    "save": "Ruaj",
    "confirm": "Konfirmo",
    "delete": "Fshij",
    "back": "Kthehu",
    "close": "Mbyll",
    "edit": "Ndrysho",
    "search": "Kërko",
    "all": "Të gjitha",
    "loading": "Duke ngarkuar...",
    "error": "Diçka shkoi keq",
    "notFound": "Nuk u gjet",
    "tryAgain": "Ju lutem provoni përsëri",
    "retry": "Riprovo",
    "undo": "Zhbëj",
    "pullToRefresh": "Tërhiq për rifreskim",
    "justNow": "sapo tani"
  },
  "auth": {
    "welcome": "Mirësevini në FishMemory",
    "tagline": "Asistenti juaj i kujtesave në WhatsApp, tani në xhepin tuaj.",
    "subtitle": "Asistenti juaj i kujtesave në WhatsApp, tani në xhepin tuaj.",
    "phoneLabel": "Numri juaj i WhatsApp",
    "phoneHint": "Do të dërgojmë një kod verifikimi përmes WhatsApp",
    "invalidPhone": "Ju lutem shkruani një numër telefoni të vlefshëm",
    "continue": "Vazhdo",
    "enterPhone": "Shkruani numrin tuaj të WhatsApp",
    "phonePlaceholder": "Numri i telefonit",
    "sendCode": "Dërgo Kodin",
    "verifyTitle": "Verifikoni numrin tuaj",
    "otpSentTo": "Një kod 6-shifror u dërgua në {{phone}} përmes WhatsApp",
    "enterFullCode": "Ju lutem shkruani të gjitha 6 shifrat",
    "invalidOtp": "Kodi i pavlefshëm. Ju lutem provoni përsëri.",
    "otpFailed": "Dështoi dërgimi i kodit. Provoni përsëri.",
    "otpResent": "Kodi u dërgua përsëri",
    "resendIn": "Ridispononi në {{seconds}}s",
    "resendCode": "Ridispononi kodin",
    "enterOtp": "Shkruani kodin e dërguar në WhatsApp",
    "verify": "Verifiko",
    "resend": "Ridispononi kodin",
    "wrongNumber": "Numër i gabuar?",
    "backToPhone": "Kthehu te telefoni",
    "editPhone": "Ndrysho numrin e telefonit",
    "error": "Gabim",
    "setupTitle": "Le të fillojmë",
    "setupSubtitle": "Këto mund t'i ndryshoni më vonë në Cilësime",
    "namePlaceholder": "Emri juaj",
    "letsGo": "Përfundo konfigurimin",
    "skipForNow": "Anulo për tani"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Shkruani një mesazh...",
    "inputPlaceholder": "Shkruani një mesazh...",
    "typing": "FishMemory po shkruan...",
    "online": "Në linjë",
    "connecting": "Duke u lidhur...",
    "reconnecting": "Duke u rilidhur...",
    "offline": "Jashtë linje",
    "empty": "Filloni një bisedë",
    "emptyHint": "Krijoni kujtese, kontrolloni orarin ose kërkoni ndihmë.",
    "emptyAction": "Dërgo një kujtesë shembull",
    "actions": "Veprimet e bisedës",
    "keep": "Mbaj mesazhet",
    "clearTitle": "Pastro bisedën",
    "clearConfirm": "Fshini të gjitha mesazhet nga ky pajisje? Kjo nuk mund të zhbëhet.",
    "clear": "Pastro bisedën",
    "optionSelected": "Zgjedhur: {{label}}",
    "sendingSelection": "Duke dërguar...",
    "connectionLost": "Duke u rilidhur..."
  },
  "reminders": {
    "title": "Kujtesat e mia",
    "active": "Aktive",
    "today": "Sot",
    "thisWeek": "Këtë javë",
    "history": "Historia",
    "items": "artikuj",
    "emptyTitle": "Nuk ka ende kujtesa",
    "emptySubtitle": "Krijo një nga biseda dhe do të shfaqet këtu.",
    "emptyAction": "Hap bisedën",
    "filterActive": "Aktive",
    "filterToday": "Sot",
    "filterWeek": "Këtë javë",
    "filterHistory": "Historia",
    "emptyState": "Nuk ka kujtesa ende. Filloni të bisedoni!",
    "swipeDone": "Bërë",
    "swipeSnooze": "Shtyj",
    "swipeDelete": "Fshij",
    "search": "Kërko kujtesa...",
    "upcoming": "Në pritje",
    "completed": "Përfunduar",
    "overdue": "Vonuar",
    "tomorrow": "Nesër",
    "synced": "Sinkronizuar {{value}}",
    "swipeHint": "Lëviz një kujtesë për më shumë veprime",
    "noResults": "Nuk u gjetën kujtesa për kërkimin tuaj",
    "noResultsHint": "Provoni një fjalë kyçe tjetër ose pastroni kërkimin",
    "deleteAllFailed": "Dështoi fshirja e të gjitha kujtesave"
  },
  "calendar": {
    "title": "Kalendar",
    "today": "Sot",
    "tomorrow": "Nesër",
    "completed": "bërë",
    "noEvents": "Asgjë e planifikuar",
    "noEventsSubtitle": "Zgjidhni një datë për të parë kujtesat dhe ngjarjet në kalendar.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktive",
    "legendRecurring": "Përsëritëse",
    "legendDone": "Bërë",
    "legendGoogle": "Google",
    "previousMonth": "Muaji i kaluar",
    "nextMonth": "Muaji tjetër",
    "previousYear": "Viti i kaluar",
    "nextYear": "Viti tjetër",
    "goToToday": "Shko te sot",
    "all": "Të gjitha",
    "active": "Aktive",
    "done": "Bërë",
    "paused": "Ndalur"
  },
  "settings": {
    "title": "Cilësimet",
    "profile": "Profili",
    "name": "Emri i shfaqur",
    "enterName": "Shkruani emrin tuaj",
    "language": "Gjuha",
    "uiLanguage": "Gjuha e aplikacionit",
    "uiLanguageHelp": "Ndryshon ndërfaqen, etiketat e kalendarit dhe drejtimin e layout-it vetëm në këtë pajisje.",
    "serverLanguage": "Gjuha e bisedës",
    "serverLanguageHelp": "Ndryshon gjuhën e përgjigjeve të serverit dhe mesazheve të kujtesave për llogarinë tuaj.",
    "timezone": "Zona kohore",
    "currentTimezone": "Zona kohore aktuale",
    "timezoneHelp": "Të gjitha kohët e kujtesave shfaqen sipas kësaj zone kohore.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Ruaj zonën kohore",
    "timezoneSaved": "Zona kohore u përditësua",
    "detect": "Zbulo",
    "detectFailed": "Nuk u zbulua zona kohore",
    "autoDetect": "Zbulim automatik nga GPS",
    "notifications": "Njoftimet",
    "notificationsHelp": "Kujtesat përsëritëse kontrollojnë paralajmërimet e përsëritura pas dërgimit të kujtesës. Lejet për njoftimet në pajisje menaxhohen në cilësimet e telefonit tuaj.",
    "pushEnabled": "Njoftimet Push",
    "autoDoneOnFire": "Shënim automatik si i përfunduar kur aktivizohet",
    "autoDoneOnFireDesc": "Kur është fikur, kujtesat mbeten aktive derisa t'i shënoni si të përfunduara.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Lidhur",
    "googleDisconnected": "Nuk është lidhur",
    "googleConnectedHelp": "Kujtesat e reja mund të sinkronizohen automatikisht me kalendarin tuaj.",
    "googleDisconnectedHelp": "Lidh Google Calendar për të mbajtur kujtesat dhe ngjarjet në përputhje.",
    "googleConnectFailed": "Dështoi lidhja me Google Calendar",
    "connected": "Lidhur",
    "disconnected": "Nuk është lidhur",
    "connect": "Lidhu",
    "disconnect": "Ç' lidhu",
    "autoSync": "Sinkronizim automatik i kujtesave të reja",
    "autosync": "Sinkronizim automatik i kujtesave të reja",
    "subscription": "Abonimi",
    "trialUsed": "Provë: {{used}}/{{total}} përdorur",
    "trialStatus": "Provë në dispozicion",
    "activeStatus": "Abonim aktiv",
    "expiredStatus": "Abonimi ka skaduar",
    "unsubscribedStatus": "Nuk jeni abonuar",
    "about": "Rreth",
    "version": "Versioni",
    "logout": "Dil",
    "logoutTitle": "Dil",
    "logoutConfirm": "Jeni i sigurt që doni të dilni?",
    "noName": "Emri nuk është vendosur",
    "serverConnection": "Lidhja me serverin",
    "serverUrl": "URL e serverit",
    "serverEdit": "Ndrysho",
    "saveReconnect": "Ruaj dhe rilidh",
    "resetDefault": "Rivendos në parazgjedhje",
    "invalidServerUrlTitle": "URL e serverit e pavlefshme",
    "invalidServerUrlMessage": "Shkruani një URL të vlefshme http ose https, për shembull https://example.com",
    "uiLanguageChangeFailed": "Dështoi ndryshimi i gjuhës së aplikacionit. Ju lutem provoni përsëri.",
    "serverLanguageChangeFailed": "Dështoi ndryshimi i gjuhës së bisedës. Ju lutem provoni përsëri.",
    "timezoneChangeFailed": "Dështoi ndryshimi i zonës kohore. Ju lutem provoni përsëri.",
    "autoSyncChangeFailed": "Dështoi përditësimi i sinkronizimit automatik. Ju lutem provoni përsëri.",
    "nameChangeFailed": "Dështoi përditësimi i emrit të shfaqur. Ju lutem provoni përsëri.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detajet e kujtesës",
    "editTime": "Ndrysho kohën",
    "rename": "Riemërto",
    "snooze": "Shtyj",
    "snooze15": "Shtyj 15 minuta",
    "pause": "Ndal",
    "pauseReminder": "Ndal kujtesën",
    "resume": "Rivendos",
    "resumeReminder": "Rivendos kujtesën",
    "skip": "Anulo të ardhshmen",
    "skipOccurrence": "Anulo këtë herë",
    "syncGoogle": "Sinkronizo me Google",
    "delete": "Fshij",
    "deleteTitle": "Fshij kujtesën",
    "deleteConfirm": "Kjo kujtesë do të fshihet përgjithmonë.",
    "deleteRecurringTitle": "Fshij kujtesën përsëritëse",
    "deleteRecurringMessage": "Doni të anulloni këtë herë apo të fshini të gjithë serinë?",
    "deleteThisOccurrence": "Anulo këtë herë",
    "deleteEntireSeries": "Fshij të gjithë serinë",
    "done": "Bërë",
    "markDone": "Shëno si bërë",
    "undo": "Rikthe",
    "undoPrompt": "Doni ta bëni përsëri aktive? Rikthe tani.",
    "recurring": "Përsëritëse",
    "nextRun": "Herën tjetër",
    "oneTime": "Një herë",
    "pending": "Në pritje",
    "sent": "Dërguar",
    "paused": "Ndalur",
    "active": "Aktive",
    "snoozed": "Shtyrë",
    "localTime": "Shfaqet në kohën lokale",
    "recurrence": "Përsëritje",
    "created": "Krijuar",
    "tags": "Etiketat",
    "fireCount": "Herë aktivizuar",
    "actions": "Veprime",
    "none": "Asnjë",
    "snoozeFailed": "Dështoi shtyrja e kujtesës",
    "pauseFailed": "Dështoi ndalja e kujtesës",
    "resumeFailed": "Dështoi rivendosja e kujtesës",
    "skipFailed": "Dështoi anulimi i kujtesës",
    "doneFailed": "Dështoi shënimi i kujtesës si bërë",
    "undoFailed": "Dështoi rikthimi i statusit të kujtesës",
    "deleteFailed": "Dështoi fshirja e kujtesës",
    "rescheduleTitle": "Riprogramo?",
    "rescheduleMsg": "Kjo kujtesë është vonuar. Dëshironi ta riprogramoni?",
    "reschedule15": "Në 15 minuta",
    "reschedule60": "Në 1 orë",
    "keepOverdue": "Lëre si është"
  },
  "onboarding": {
    "slide1Title": "Mirësevini në FishMemory",
    "slide1Sub": "Asistenti juaj personal i kujtesave — i fuqizuar nga WhatsApp dhe ndërtuar për xhepin tuaj.",
    "slide2Title": "Thjesht bisedoni natyrshëm",
    "slide2Sub": "Shkruani kujtesat ashtu si mendoni: \"Më kujtoji të telefonoj mamanë nesër në orën 15\" — ne kujdesemi për pjesën tjetër.",
    "slide3Title": "Mos humbisni asgjë",
    "slide3Sub": "Merrni njoftime në kohë, organizohuni me etiketa dhe qëndroni në krye të gjithçkaje që ka rëndësi.",
    "getStarted": "Filloni",
    "next": "Tjetër",
    "firstReminderTitle": "Krijoni kujtesën tuaj të parë!",
    "firstReminderHint": "Provoni të shkruani diçka si:",
    "firstReminderExample": "Më kujtoji të pi ujë nesër në orën 9:00",
    "gotIt": "Kuptova!",
    "notifRationaleTitle": "Qëndroni në kohë",
    "notifRationaleBody": "FishMemory ka nevojë për njoftime për t'ju kujtuar në kohë. Do të merrni paralajmërime vetëm për kujtesat që krijoni.",
    "notifRationaleAllow": "Aktivizo njoftimet",
    "notifRationaleLater": "Ndoshta më vonë",
    "swipeHint": "Lëviz djathtas për veprime të shpejta →",
    "calendarDragHint": "Tërhiq për të zmadhuar ↕"
  }
}
